import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  municipio_selected: {}, //seleccionara el objeto de la lista de magistrados
  municipios: []
};
export const mutations = {
  SELECT_MUNICIPIO({ context }, municipio) {
    return (state.municipio_selected = Object.assign({}, municipio));
  },
  FILL_MUNICIPIOS({ context }, list_municipios) {
    let municipios = [];
    Object.entries(list_municipios).forEach(([key, val]) =>
      municipios.push(val)
    );
    return (state.municipios = municipios);
  }
};
export const actions = {
  GET_ALL_MUNICIPIOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_MUNICIPIOS", response.data.data.municipios);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_MUNICIPIO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_MUNICIPIO({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_MUNICIPIO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllMunicipios: state => {
    const filtros = state.municipios.filter(municipio => {
      if (municipio.estado_id == 14) {
        return true;
      }
    });
    return filtros;
  },
  getMunicipiosActivos: state => {
    const activos = state.municipios.filter(municipio => {
      // console.log("municipio");
      if (municipio.activo) {
        return true;
      }
    });
    // console.log("mis municipios activos", activos);
    return activos;
  },
  getMunicipioSelected: state => {
    return state.municipio_selected;
  }
};
